import { a as _defineProperty } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default, { useContext } from 'react';
import cx from 'classnames';
import { T as ThemeContext } from './ThemeContext-e1f446be.js';
import { E as ErrorIcon } from './index-56745294.js';
import Tooltip from './tooltip.js';
import './tooltipAnchor.js';

const ViewportContext = /*#__PURE__*/React__default.createContext({});
class ViewportProvider extends React__default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "debouncedHandleResize", () => {
      clearTimeout(this.resizeListener);
      this.resizeListener = setTimeout(this.handleResize, 300);
    });
    _defineProperty(this, "handleResize", () => {
      this.setState({
        innerWidth: window.innerWidth
      });
    });
    this.state = {
      innerWidth: null
    };
  }
  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.debouncedHandleResize, {
      passive: true
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedHandleResize, {
      passive: true
    });
  }
  render() {
    return /*#__PURE__*/React__default.createElement(ViewportContext.Provider, {
      value: this.state
    }, this.props.children);
  }
}
const withViewportProvider = WrappedComponent => {
  const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';
  const WithViewportProvider = props => /*#__PURE__*/React__default.createElement(ViewportProvider, null, /*#__PURE__*/React__default.createElement(WrappedComponent, props));
  WithViewportProvider.displayName = `WithViewportProvider(${getDisplayName(WrappedComponent)})`;
  return WithViewportProvider;
};

const breakpointMobile = 768; // breakpoint to position tooltip to bottom
const feedbackTooltipMaxWidth = 350;
const FeedbackTooltip = props => {
  const themeContext = useContext(ThemeContext);
  const viewportContext = useContext(ViewportContext);
  const {
    appendTo,
    children,
    fillWidth = false,
    content,
    intent,
    placement = 'right',
    placementFlipped = 'bottom',
    maxWidth = feedbackTooltipMaxWidth,
    tooltipWithinParent,
    tooltipIcon
  } = props;
  const renderTooltipOverlay = content => /*#__PURE__*/React__default.createElement("div", {
    className: "mw-feedback-tooltip-content"
  }, tooltipIcon, /*#__PURE__*/React__default.createElement("p", null, content));
  const appTheme = props.theme || themeContext && themeContext.theme;
  const isMobileView = viewportContext && viewportContext.innerWidth <= breakpointMobile;
  const visible = (intent === 'error' || intent === 'warning') && !!content;
  const sameWidthAsParent = isMobileView || fillWidth;
  const tooltipProps = {
    tooltipTheme: appTheme === 'dark' ? 'dark' : 'light',
    visible,
    overlay: renderTooltipOverlay(content),
    maxWidth,
    placement,
    className: cx('mw-feedback-tooltip', 'mw-tooltip--bordered', sameWidthAsParent && 'mw-feedback-tooltip--fill-width'),
    flip: false,
    flipBehavior: [placement, placementFlipped],
    flipOnUpdate: true,
    interactive: true
  };
  if (!!appendTo && (tooltipWithinParent || sameWidthAsParent)) {
    tooltipProps.appendTo = appendTo;
  }
  return /*#__PURE__*/React__default.createElement(Tooltip, tooltipProps, children);
};
FeedbackTooltip.defaultProps = {
  tooltipIcon: /*#__PURE__*/React__default.createElement(ErrorIcon, null)
};

export { FeedbackTooltip as F, ViewportContext as V, withViewportProvider as w };
